import { render, staticRenderFns } from "./CustomListDetails.vue?vue&type=template&id=0f17d191&scoped=true&"
import script from "./CustomListDetails.vue?vue&type=script&lang=js&"
export * from "./CustomListDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomListDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17d191",
  null
  
)

export default component.exports